import { FactoryProvider } from '@angular/core';
import { ApiConfig, createDefaultConfig } from 'bimplus-websdk';
import { BIMPLUS_API_CONFIG } from '@web-portal/domains/shared/bimplus-core';
import { BimplusWebsdkConfig } from '../';

export const defaultBimplusApiConfigProvider: (
  config: BimplusWebsdkConfig
) => FactoryProvider = config => ({
  provide: BIMPLUS_API_CONFIG,
  useFactory: (): ApiConfig => {
    const envString = config.environment === 'prod' ? '' : config.environment;
    return createDefaultConfig(envString);
  },
});
